import React from 'react';
import { observer } from 'mobx-react';

const HeaderPage = ({ title, content, bgmCode = null }) => {
  return (
    <div className="py-10 w-full text-center lg:pt-20">
      <p className="font-notoSans text-4xl  xs:text-5xl md:text-7xl font-black pb-3">
        {title}
      </p>
      <p className=" px-[30px] text-[#3d3d3d] text-sm xs:text-xl md:text-xl pt-5">
        {content}
      </p>
    </div>
  );
};

export default observer(HeaderPage);
